import { render, staticRenderFns } from "./SupplierComponent.vue?vue&type=template&id=aa8ed960&scoped=true&"
import script from "./SupplierComponent.vue?vue&type=script&lang=js&"
export * from "./SupplierComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8ed960",
  null
  
)

export default component.exports